import React from 'react';

import Link from 'next/link';
import { useParams } from 'next/navigation';

import { useTranslation } from 'hooks/useTranslation';

import Container from 'components/Container';
import Icon from 'components/Icon';

import { styles } from '.';

const ErrorLayout = () => {
  const params = useParams();
  const { t } = useTranslation(params?.lang as string);

  return (
    <div className={styles.container}>
      <Container type="center">
        <div className={styles.content}>
          <div className={styles.head}>
            <h1 className={styles.title}>Oops.</h1>
            <p className={styles.description}>
              {t('layout.error.description')}
            </p>
          </div>
          <Link href="/">
            <div className={styles.button.container}>
              <Icon type="sharp-light" accessor="arrow-right-long" />
              <p className={styles.button.label}>{t('layout.error.button')}</p>
            </div>
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default ErrorLayout;
